import { render, staticRenderFns } from "./propiedadFamiliaProducto.vue?vue&type=template&id=50925f8b&scoped=true&"
import script from "./propiedadFamiliaProducto.vue?vue&type=script&lang=js&"
export * from "./propiedadFamiliaProducto.vue?vue&type=script&lang=js&"
import style0 from "./propiedadFamiliaProducto.vue?vue&type=style&index=0&lang=css&"
import style1 from "./propiedadFamiliaProducto.vue?vue&type=style&index=1&id=50925f8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50925f8b",
  null
  
)

export default component.exports